module.exports = ".wp-sidebar-icon {\n  min-width: 25px;\n  text-align: center;\n  vertical-align: middle; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/layout/sidebar/sidebar.component.scss
// module id = 587
// module chunks = 8